import React, { FunctionComponent } from 'react';

import Main from '../layout/Main';

import AdminNavBar from './layout/AdminNavBar';
import {Navigate, Outlet} from 'react-router-dom';
import {useAuth} from '../../contexts/AuthContext';

interface Props {}

const AdminContent: FunctionComponent<Props> = () => {
    const { isAdmin } = useAuth();

    if(!isAdmin) {
        return <Navigate to={'/'} />
    }

    return (
        <React.Fragment>
            <AdminNavBar />

            <Main>
                <Outlet />
            </Main>
        </React.Fragment>
    );
};

export default AdminContent;
